export default __webpack_public_path__ + "static/media/easter-login-bg.8a2dee41.jpg";